module.exports = __webpack_public_path__ + "static/media/nLogo.5725af17.svg";